<div
  [ngClass]="{
    'm-auto': !isOrganization,
    'mx-auto mb-6 mt-1': isOrganization
  }"
  class="review-container relative"
>
  <div (click)="onVideoClick(review?.videoReviewUrl)" class="review-video">
    <img
      #coverImage
      (load)="calcCover()"
      [ngStyle]="{ 'object-fit': isCoverLandscape ? 'cover' : 'contain' }"
      [src]="review?.videoReviewThumbnailUrl + '?time=0&fit_mode=smartcrop'"
      class="h-auto"
    />
    <img
      [ngStyle]="{ display: !review.isVideoPlaying ? 'block' : 'none' }"
      class="play-icon"
      src="/assets/images/play-icon.svg"
    />
  </div>
  <div class="review-info">
    <div class="user-info">
      <span class="grid flex-column m-0">
        <span class="user-name">{{ review?.user?.firstName }}</span>
        <span>{{ createdAt }}</span>
      </span>
      <span class="grid align-items-center m-0">
        <i
          (click)="toggleMenu($event)"
          class="report-review pi pi-ellipsis-h"
        ></i>
      </span>
    </div>
  </div>

  <div
    *ngIf="isOrganization && review?.isNew"
    class="new-review-badge absolute uppercase p-1 bg-pink color-white"
  >
    New
  </div>

  <div
    *ngIf="isOrganization && review"
    class="grid align-items-center m-0 switch-block absolute"
  >
    <label class="text-xs" for="approve">Display on PitchCards</label>

    <p-toggleswitch
      id="approve"
      (onChange)="setTestimonialVisibility($event.checked)"
      [disabled]="review.isOnModeration"
      [(ngModel)]="review.isVisible"
      styleClass="scale-08"
    >
    </p-toggleswitch>
  </div>
</div>
